import { DiscountTypeEnum, VatEnum } from '@/utils/enums';
import { translation } from '@/helpers/TranslationHelper';
import { sum } from 'lodash';
import { getSign } from '@/helpers/SignHelper';
import LocalStorage from '@/helpers/LocalStorageHelper';
// import { cart } from '../store/modules/cart';


// manual number rounding
// Number.prototype.mtoFixed = function() {
//     if(this === +this && this !== (this|0)) {
//         var iToString = this + '';
//         let formated = parseFloat(iToString.match(/\d+\.\d{2}/)).toString();
//         if(isNaN(formated)) {
//             return this.toFixed(2)
//         } else {
//             return formated;
//         }
//     } else {
//         return this.toString();
//     }
// }

Number.prototype.mtoFixed = function() {
    if (isNaN(this)) return '0.00'; // Jei nėra skaičius, grąžinti "0.00"
    
    let num = this;
    let isNegative = num < 0;
    num = Math.abs(num); // Paverčiam į teigiamą skaičių, kad tvarkytume formatavimą

    let formatted = num.toFixed(2); // Suapvalinam iki 2 skaitmenų
    return isNegative ? `-${formatted}` : formatted; // Jei buvo neigiamas, grąžinam su "-"
};


export const getPriceWithDiscount = (price, discountAmount, discountType) => {
    switch (discountType) {
        case DiscountTypeEnum.PERCENTAGE:
            return (price - (price * discountAmount) / 100).toFixed(2);
        case DiscountTypeEnum.FIXED:
            return (price - discountAmount).toFixed(2);

        default:
            return price.toFixed(2);
    }
};

export const getDiscount = (price, discountAmount, discountType = DiscountTypeEnum.PERCENTAGE) => {
    switch (discountType) {
        case DiscountTypeEnum.PERCENTAGE:
            return ((price * discountAmount) / 100).toFixed(2);
        case DiscountTypeEnum.FIXED:
            return discountAmount.toFixed(2);
        default:
            return (0).toFixed(2);
    }
};

export const getMealKitPrice = (mealKit, amount, periodAmount, caloriePrice) => {
    if (!mealKit.isUnique) {
        return (caloriePrice * amount * periodAmount).toFixed(2);
    }

    return (amount * mealKit.price).toFixed(2);
};

export const getPricesArray = (state, calcFunc, field, multiplier) => {
    let priceArray = [];
    state.forEach((element) => {
        priceArray.push(Number(calcFunc(element[field], multiplier)));
    });

    return priceArray;
};

export const getAdditionPrice = (price, periodAmount) => {
    return (periodAmount * price).toFixed(2);
};

export const getAllergenPrice = (percentage, mealKitPrice) => {
    return ((mealKitPrice * percentage) / 100).toFixed(2);
};

export const getTotalMealKitPrice = (mealKit, additions, periodAmount, mealKitPriceWithDiscount) => {
    if (!mealKit.isUnique) {
        let additionsPriceArray = getPricesArray(additions, getAdditionPrice, 'price', periodAmount);

        return (Number(mealKitPriceWithDiscount) + Number(sum(additionsPriceArray))).toFixed(2);
    }

    return mealKitPriceWithDiscount.toFixed(2);
};

export const getPriceForAllAllergens = (allergens, mealKitPrice) => {
    let allergensPriceArray = getPricesArray(allergens, getAllergenPrice, 'percentage', mealKitPrice);

    return Number(sum(allergensPriceArray)).toFixed(2);
};


// when is fixed discount amount * itemAmount
export const calculateDiscountAmount = (type, itemAmount, discountAmount) => {
    if(type === DiscountTypeEnum.FIXED) {
        return discountAmount * itemAmount;
    } else {
        return discountAmount;
    }
}

export const getMealKitAllPrices = (item) => {
    const caloriePrice = item.calorie?.prices.find((elem) => elem.period_id === item.period?.id).price;

    const mealKitPrice = getMealKitPrice(item.mealKit, item.amount, item.period?.amount, caloriePrice);

    const mealKitPriceWithAllergens =
        Number(mealKitPrice) + Number(getPriceForAllAllergens(item.allergens, Number(mealKitPrice)));

    const mealKitPriceWithDiscount = getPriceWithDiscount(
        Number(mealKitPriceWithAllergens),
        item.mealKit.discount?.amount,
        item.mealKit.discount?.type
    );

    const totalPrice = getTotalMealKitPrice(
        item.mealKit,
        item.additions,
        item.period?.amount,
        Number(mealKitPriceWithDiscount)
    );


    const discountAmount = getDiscount(
        mealKitPriceWithAllergens,
        calculateDiscountAmount(item.mealKit.discount?.type, item.amount, item.mealKit.discount?.amount),
        item.mealKit.discount?.type
    );

    const totalPriceWithoutDiscount = getTotalMealKitPrice(
        item.mealKit,
        item.additions,
        item.period?.amount,
        Number(mealKitPriceWithAllergens)
    );

    return {
        mealKitPrice,
        mealKitPriceWithDiscount,
        totalPrice,
        mealKitPriceWithAllergens,
        discountAmount,
        totalPriceWithoutDiscount,
    };
};

export const calcCommonPrices = (cart, deliveryPrices, vatData, appliedDiscountPoints) => {
    const priceArray = [];
    const discountCodesArray = [];

    const discountWithPoints = appliedDiscountPoints ? appliedDiscountPoints.discountWithPoints : 0;
    let isFreeDelivery = false;
    let fixedCartDiscount = 0;

    cart.forEach((element) => {
        priceArray.push(Number(element.totalPrice));

        if (element.appliedDiscountCodes.length) {
            element.appliedDiscountCodes.forEach((discountFromCodeAmount) => {
                if (discountFromCodeAmount.isFreeDelivery === true) {
                    isFreeDelivery = true;
                }

                if (discountFromCodeAmount.applyToCart && discountFromCodeAmount.type === DiscountTypeEnum.FIXED) {
                    fixedCartDiscount = discountFromCodeAmount.amount;
                } else {
                    discountCodesArray.push(Number(discountFromCodeAmount.price));
                }
            });
        }
    });

    // 1️⃣ **Prekių suma be nuolaidų**
    let priceWithoutDiscount = sum(priceArray).toFixed(2);

    // 2️⃣ **Pristatymo kainos skaičiavimas**
    let deliveryPrice = 0;
    let uniquePrice = 0;
    let regularDeliveryPrice = 0;
    let uniqueDeliveryPrice = 0;

    const uniqueKitsAmount = cart.filter((cartItem) => cartItem.mealKit.isUnique).length;
    const regularKits = cart.filter((cartItem) => !cartItem.mealKit.isUnique);

    if (deliveryPrices.length && !isFreeDelivery) {
        if (regularKits.length) {
            const periodAmountArray = regularKits.map((kit) => kit.period.amount);
            const maxPeriodAmount = Math.max(...periodAmountArray);
            regularDeliveryPrice = Number(deliveryPrices.find((price) => !price?.isForUnique).price) * maxPeriodAmount;
        }

        if (uniqueKitsAmount) {
            uniquePrice = Number(deliveryPrices.find((price) => price.isForUnique).price);
        }

        uniqueDeliveryPrice = uniquePrice * uniqueKitsAmount;
        deliveryPrice = regularDeliveryPrice + uniqueDeliveryPrice;
    }

    // 3️⃣ **Taikome `applyToCart` fiksuotą nuolaidą prekėms**
    let remainingDiscount = 0;
    let discountedItemsTotal = priceWithoutDiscount;

    if (fixedCartDiscount > 0) {
        if (fixedCartDiscount >= priceWithoutDiscount) {
            remainingDiscount = fixedCartDiscount - priceWithoutDiscount;
            discountedItemsTotal = 0;
        } else {
            discountedItemsTotal = (priceWithoutDiscount - fixedCartDiscount).toFixed(2);
        }
    }

    // 4️⃣ **Jei liko nuolaidos, taikome ją pristatymui**
    let discountedDeliveryPrice = deliveryPrice;

    if (remainingDiscount > 0 && deliveryPrice > 0) {
        discountedDeliveryPrice = Math.max(deliveryPrice - remainingDiscount, 0);
    }

    // 5️⃣ **Taikome kitas nuolaidas (kodai, taškai)**
    const discountFromCodes = sum(discountCodesArray).mtoFixed();
    const discountFromPoints = Number(discountWithPoints).mtoFixed();
    const commonDiscount = (Number(discountFromCodes) + Number(discountFromPoints)).mtoFixed(2);

    // 6️⃣ **Galutinė suma po visų nuolaidų**
    let totalPriceWithOutDelivery = Math.max(Number(discountedItemsTotal) - Number(commonDiscount), 0).toFixed(2);
    let totalPrice = Math.max(Number(totalPriceWithOutDelivery) + Number(discountedDeliveryPrice), 0).toFixed(2);

    // 7️⃣ **PVM skaičiavimai**
    const { kitVatPrice, deliveryVatPrice, vat } = calcVat(vatData, totalPriceWithOutDelivery, discountedDeliveryPrice);

    return {
        priceWithoutDiscount,
        discountFromCodes,
        discountFromPoints,
        commonDiscount,
        totalPrice,
        totalPriceWithOutDelivery, // ✅ **Pridėta, kad frontend gautų šią reikšmę**
        vat,
        kitVatPrice,
        deliveryVatPrice,
        deliveryPrice: discountedDeliveryPrice.toFixed(2), // Tikras pristatymo mokestis po nuolaidos
        uniqueDeliveryPrice: uniqueDeliveryPrice.toFixed(2),
        regularDeliveryPrice: regularDeliveryPrice.toFixed(2),
    };
};



export const getApplyedDiscountText = (discountCode) => {
    if(discountCode.isFreeDelivery && discountCode.amount === 0) {
        return translation('common.freeDelivery');
    } else {
        return translation('common.discountApplied', {
            amount: discountCode.amount,
            sign: getSign(discountCode.type),
        })
    }
}

export const applyDiscountCodeToCartItem = (discountCode, cart, mode = 'add') => {
    let codesArray = [];
    discountCode.mealKitsIds.forEach((mealKitId) => {
        cart.forEach((cartItem) => {
            let periodCheck = (mealKitId.periods === null ? true : mealKitId.periods.includes(cartItem.period.id));
            if (cartItem.mealKit.id === mealKitId.id && periodCheck) {
                if (
                    mode === 'add' // &&
                    // !(codesArray.includes(discountCode) && discountCode.type === DiscountTypeEnum.FIXED)
                ) {
                    cartItem.appliedDiscountCodes.push({
                        id: discountCode.id,
                        amount: discountCode.amount,
                        type: discountCode.type,
                        applyToCart: discountCode.applyToCart,
                        isFreeDelivery: discountCode.isFreeDelivery,
                        text: getApplyedDiscountText(discountCode),
                        price: Number(getDiscount(
                            cartItem.totalPrice,
                            calculateDiscountAmount(discountCode.type, cartItem.amount, discountCode.amount),
                            discountCode.type
                        )),
                    });

                    codesArray = codesArray.concat(discountCode);
                } else {
                    cartItem.appliedDiscountCodes = cartItem.appliedDiscountCodes.filter(
                        (item) => item.id !== discountCode.id
                    );
                }
            }

            LocalStorage.create(`cart-item-${cartItem.id}`, cartItem);
        });
    });
};

export const updateAppliedDiscountCodeInCartItem = (cartItem) => { 
    cartItem.appliedDiscountCodes.forEach((element) => {
        console.log(element);
        let discountBase = calculateDiscountAmount(element.type, cartItem.amount, element.amount, element.applyToCart)
        // const discountBase = element.type === DiscountTypeEnum.FIXED
        // ? element.amount * cartItem.amount // FIXED: įtraukiamas kiekis
        // : element.amount; // PERCENTAGE: kiekis neskaičiuojamas

        element.price = Number(getDiscount(cartItem.totalPrice, discountBase, element.type));

        LocalStorage.create(`cart-item-${cartItem.id}`, cartItem);
    });
};

export const calcVat = (vatData, totalPriceWithOutDelivery, deliveryPrice) => {
    const kitVATPercentage = vatData.find((vatItem) => vatItem.type === VatEnum.KIT)?.percentage;
    const deliveryVATPercentage = vatData.find((vatItem) => vatItem.type === VatEnum.DELIVERY)?.percentage;

    const kitVatPrice = getDiscount(Number(totalPriceWithOutDelivery), kitVATPercentage, DiscountTypeEnum.PERCENTAGE);
    const deliveryVatPrice = getDiscount(Number(deliveryPrice), deliveryVATPercentage, DiscountTypeEnum.PERCENTAGE);

    const vat = (Number(kitVatPrice) + Number(deliveryVatPrice)).mtoFixed(2);

    return {
        kitVatPrice,
        deliveryVatPrice,
        vat,
    };
};
